<template>
  <div id="app" v-bind:class="{ mobile: mobile }">
    <div class="menu" v-bind:style="[backgroundMenu]">
      <router-view name="menu"></router-view>
      <ToPaid v-if="!mobile"></ToPaid>
    </div>
    <div class="main" v-bind:style="[backgroundMain]">
      <router-view name="main"></router-view>
    </div>
  </div>
</template>

<script>
import { colors } from "./services/settings.const";
import tinycolor from "tinycolor2";

export default {
  data() {
    return {
      background: colors.background,
      mobile: false,
    };
  },
  mounted() {
    this.mobile = this.$piggyBank.mobile;
    this.$root.$on("mobile", (mobile) => (this.mobile = mobile));
    this.background = this.$piggyBank.data.settings.general.color;
  },
  computed: {
    backgroundMenu() {
      return {
        background: this.$piggyBank.data.settings.general.color,
      };
    },
    backgroundMain() {
      const tc = tinycolor(this.$piggyBank.data.settings.general.color);

      return {
        background: tc.lighten(40).toString(),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;
  justify-items: stretch;

  & > .menu {
    flex: 1;
  }

  & > .main {
    position: relative;
    flex: 2;
    overflow-y: auto;
  }

  &.mobile {
    flex-direction: column;

    & > .menu {
      flex: initial;
    }

    & > .main {
      position: relative;
      flex: 2;
      overflow-y: auto;
    }
    // & > .menu {
    //   position: fixed;
    //   width: 100%;
    //   top: 0;
    //   left: 0;
    //   z-index: 100000;
    // }
  }
}
</style>